import React from 'react';

export default function Splash() {
  return <div className='splash-container'>Splash</div>;
}
